// Direct replacement for the deprecated @babel/polyfill (core-js 2 +
// regenerator-runtime). regenerator-runtime is still required: pre-transpiled
// packages like dexie-export-import call the regeneratorRuntime global.
import 'core-js/stable';
import 'regenerator-runtime/runtime';

// fetch() polyfill for making API calls.
// require('whatwg-fetch');
